import { PWSProgram } from '@120wateraudit/envirio-components/dist/models'

import { ApplicationState } from '../reducers'

export const getProgram = (
  state: ApplicationState
): PWSProgram | Record<string, unknown> =>
  state.program.item ? state.program.item : {}
